import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import VideoRule1 from "@/assets/custom-digital-human-rule/video_rule_3.webp";
import VideoRule2 from "@/assets/custom-digital-human-rule/video_rule_3@2x.webp";
import VideoRule3 from "@/assets/custom-digital-human-rule/video_rule_3@3x.webp";

export const VideoRule3Image = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[VideoRule3]}
      {...props}
    />
  );
};

VideoRule3Image.displayName = 'VideoRule3Image';